<template>
  <div id="Detail">
    <Drawer
        :title="editTitle"
        v-model="showDrawer"
        width="520"
        :mask-closable="false"
    >
      <Form ref="infoForm" :model="infoFormData" :rules="ruleValidate" label-position="left" :label-width="85" :label-colon="true">
        <FormItem label="证书编号" prop="cer_no">
          <Input v-model="infoFormData.cer_no" placeholder="请输入证书编号"/>
        </FormItem>
        <FormItem label="会员姓名" prop="m_name">
          <Input v-model="infoFormData.m_name" placeholder="请输入会员姓名"/>
        </FormItem>
        <FormItem label="性 别" prop="m_sex">
          <Select v-model="infoFormData.m_sex" placeholder="请选择会员性别">
            <Option value="1">男</Option>
            <Option value="2">女</Option>
          </Select>
        </FormItem>
        <FormItem label="出生日期" prop="birth">
          <DatePicker type="date" v-model="infoFormData.birth" placeholder="请选择出生日期" style="width: 100%;"></DatePicker>
        </FormItem>
        <FormItem label="身份证号" prop="m_id">
          <Input v-model="infoFormData.m_id" placeholder="请输入会员身份证号"/>
        </FormItem>
        <FormItem label="段位级别" prop="level_index">
          <Select v-model="infoFormData.level_index" placeholder="请选择段位级别">
            <Option v-for="(level,index) in levelList" v-model="level['level_index']">{{level['level_name']}}</Option>
          </Select>
        </FormItem>
        <FormItem label="考试日期" prop="time">
          <DatePicker type="date" v-model="infoFormData.time" placeholder="请选择考试日期" style="width: 100%;"></DatePicker>
        </FormItem>
<!--        <FormItem label="所属分盟" prop="lea_name">-->
<!--          <Input v-model="infoFormData.lea_name" placeholder="请输入所属分盟"/>-->
<!--        </FormItem>-->
        <FormItem label="考官编号" prop="lea_leader">
          <Input v-model="infoFormData.lea_leader" placeholder="请输入考官编号"/>
        </FormItem>
      </Form>
      <div style="text-align: right;">
        <Button style="margin-right: 8px" @click="cancelAction">取 消</Button>
        <Button type="primary" @click="saveAction">保 存</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
import { getLevels } from "@/request/levels";
import { editGradeInfo } from "@/request/dans";

export default {
  name: "Detail",
  // 注册组件
  components: {},
  props: {},
  // 计算属性，用来监控自己定义的变量，该变量不在data里面声明，直接在computed里面定义，然后就可以在页面上进行双向数据绑定展示出结果或者用作其他处理
  computed: {},
  data () {
    return {
      levelList: [],
      editTitle: '',
      showDrawer: false,
      infoFormData: {
        cer_no: '',
        m_name: '',
        birth: '',
        m_id: '',
        m_sex: '1',
        level_index: '',
        time: '',
        lea_name: '',
        lea_leader: ''
      },
      ruleValidate: {
        cer_no: [
          { required: true, message: '请输入证书编号', trigger: 'blur' }
        ],
        m_name: [
          { required: true, message: '请输入会员名称', trigger: 'blur' }
        ],
        m_sex: [
          { required: true, message: '请选择会员性别'}
        ],
        level_index: [
          { required: true, message: '请选择段位级别'}
        ],
        // lea_name: [
        //   { required: true, message: '请输入分盟名称'}
        // ],
        birth: [
          { required: true, type: 'date', message: '请选择出生日期', trigger: 'change' }
        ],
        time: [
          { required: true, type: 'date', message: '请选择考试日期', trigger: 'change' }
        ],
        lea_leader: [
          { required: true, message: '请输入考官编号'}
        ]
      }
    }
  },
  methods: {
    editDanInfo(action, rankInfo) {
      this.infoFormData = action === 'create'
          ? {
            $edit: 'create',
            cer_no: '',
            m_name: '',
            birth: '',
            m_id: '',
            m_sex: '1',
            level_index: '',
            time: '',
            lea_name: '',
            lea_leader: ''
          }
          : {
            $edit: 'update',
            ...rankInfo
          };

      this.editTitle = action === 'create' ? '添加段位证书' : '编辑段位证书';

      this.showDrawer = true;
    },
    handleGetLevels() {
      getLevels({ cate: 2 }).then(res=> {
        this.levelList = res.data.data['list']
      })
    },
    cancelAction() {
      this.$refs['infoForm'].resetFields();
      this.showDrawer = false;
    },
    saveAction() {
      this.$refs['infoForm'].validate((valid) => {
        if (valid) {
          editGradeInfo({ gradeInfo: this.infoFormData }).then(res=> {
            let { error, message } = res.data
            if (error === 200) {
              this.$Notice.success({
                title: '成功提示',
                desc: message
              })

              this.$refs['infoForm'].resetFields();
              this.showDrawer = false;
              // 调用父组件，刷新证书列表
              this.$emit('refresh');
            }else {
              this.$Notice.error({
                title: '错误提示',
                desc: message
              })
            }
          })
        }
      })
    }
  },
  created () {
    this.handleGetLevels();
  }
}
</script>

<style scoped>

</style>
